module.exports = __webpack_public_path__ + "img/Envelope.de7b1489.svg";